import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  EVALUATION_USER_LIST,
  EVALUATION_USER_SEARCH_EVALUATION_ROLE,
  EVALUATION_USER_SEARCH_USER,
  EVALUATION_USER_ADD,
  EVALUATION_USER_DETAIL,
  EVALUATION_USER_UPDATE,
  EVALUATION_USER_UPLOAD_SET
} from '../../actions';
import {
  EvaluationUserListSuccess,
  EvaluationUserListError,
  EvaluationUserSearchEvaluationRoleSuccess,
  EvaluationUserSearchEvaluationRoleError,
  EvaluationUserSearchUserSuccess,
  EvaluationUserSearchUserError,
  EvaluationUserAddSuccess,
  EvaluationUserAddError,
  EvaluationUserDetailSuccess,
  EvaluationUserDetailError,
  EvaluationUserUpdateSuccess,
  EvaluationUserUpdateError,
  EvaluationUserUploadSetSuccess,
  EvaluationUserUploadSetError
} from '../../actions';
 
export function* watchEvaluationUserList() {
  yield takeEvery(EVALUATION_USER_LIST, onEvaluationUserList);
}

export function* watchEvaluationUserSearchEvaluationRole() {
  yield takeEvery(EVALUATION_USER_SEARCH_EVALUATION_ROLE, onEvaluationUserSearchEvaluationRole);
}

export function* watchEvaluationUserSearchUser() {
  yield takeEvery(EVALUATION_USER_SEARCH_USER, onEvaluationUserSearchUser);
}

export function* watchEvaluationUserAdd() {
  yield takeEvery(EVALUATION_USER_ADD, onEvaluationUserAdd);
}

export function* watchEvaluationUserDetail() {
  yield takeEvery(EVALUATION_USER_DETAIL, onEvaluationUserDetail);
}

export function* watchEvaluationUserUpdate() {
  yield takeEvery(EVALUATION_USER_UPDATE, onEvaluationUserUpdate);
}

export function* watchEvaluationUserUpload() {
  yield takeEvery(EVALUATION_USER_UPLOAD_SET, onEvaluationUserUpload);
}

const onEvaluationUserListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_user/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationUserUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_user/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEvaluationUserSearchEvaluationRoleAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/evaluation_role', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};


const onEvaluationUserSearchUserAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/user', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onEvaluationUserAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_user/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEvaluationUserDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_user/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationUserUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/evaluation_user/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_evaluation_users/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_evaluation_users/'});
      });
    });
  });
};


function* onEvaluationUserList(data) {
  try {
    const response = yield call(onEvaluationUserListAsync, data.payload);
    yield put(EvaluationUserListSuccess(response.data));
  } catch (error) {
    yield put(EvaluationUserListError(error));
  }
}

function* onEvaluationUserSearchEvaluationRole(data) {
  try {
    const response = yield call(onEvaluationUserSearchEvaluationRoleAsync, data.payload);
    yield put(EvaluationUserSearchEvaluationRoleSuccess(response.data));
  } catch (error) {
    yield put(EvaluationUserSearchEvaluationRoleError(error));
  }
}


function* onEvaluationUserSearchUser(data) {
  try {
    const response = yield call(onEvaluationUserSearchUserAsync, data.payload);
    yield put(EvaluationUserSearchUserSuccess(response.data));
  } catch (error) {
    yield put(EvaluationUserSearchUserError(error));
  }
}

function* onEvaluationUserAdd(data) {
  try {
      const response = yield call(onEvaluationUserAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationUserAddSuccess(response.data));
  } catch (error) {
      yield put(EvaluationUserAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEvaluationUserDetail(data) {
  try {
    const response = yield call(onEvaluationUserDetailAsync, data.payload);
    yield put(EvaluationUserDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EvaluationUserDetailError(error));
  }
}

function* onEvaluationUserUpdate(data) {
  try {
      const response = yield call(onEvaluationUserUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationUserUpdateSuccess(response.data));
  } catch (error) {
      yield put(EvaluationUserUpdateError(error));
  }
}

function* onEvaluationUserUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onEvaluationUserUploadAsync, file);
    if(response.message ==='success'){
      yield put(EvaluationUserUploadSetSuccess(response));
    }
    else{
      yield put(EvaluationUserUploadSetError(response));
    }
  } catch (error) {
    yield put(EvaluationUserUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEvaluationUserList),
    fork(watchEvaluationUserSearchEvaluationRole),
    fork(watchEvaluationUserSearchUser),
    fork(watchEvaluationUserAdd),
    fork(watchEvaluationUserDetail),
    fork(watchEvaluationUserUpdate),
    fork(watchEvaluationUserUpload),
  ]);
} 